import React from 'react';
import { ZOOM_PRESETS } from './useChartZoom';

/** Segmented All / 1h / 3h control rendered above a chart (replaces Highcharts' rangeSelector). */
const ZoomControl = ({ value, onChange, labels }) => (
    <div role="radiogroup" aria-label={labels.zoom}
         className="inline-flex items-center gap-0.5 rounded-md bg-slate-100 dark:bg-slate-700/60 p-0.5 text-xs">
        {ZOOM_PRESETS.map((p) => {
            const active = value === p.key;
            return (
                <button key={p.key} type="button" role="radio" aria-checked={active} onClick={() => onChange(p.key)}
                        className={`min-h-[28px] px-2.5 rounded transition-colors ${
                            active
                                ? 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white font-semibold shadow-sm'
                                : 'text-slate-500 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white'
                        }`}>
                    {labels[p.key]}
                </button>
            );
        })}
    </div>
);

export default ZoomControl;
